const UpNav = ({ fill }: { fill: string }) => {
  return (
    <svg height='9' width='14'>
      <path
        fill={fill}
        d='M11.996 8.121l1.414-1.414L6.705 0 0 6.707l1.414 1.414 5.291-5.293z'
      ></path>
    </svg>
  );
};

export default UpNav;
